import { Box as MuiBox, styled } from '@mui/material';

export const List = styled('ul')({
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '& li': {
    padding: 0,
    listStyle: 'none',
  },
  '& li:first-child button': {
    border: '2px solid #5166B2',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: '#5166B2',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:last-child button': {
    border: '2px solid #5166B2',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: '#5166B2',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:first-child button:disabled': {
    border: '2px solid #999EB0',
    display: 'flex',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    color: '#999EB0',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& li:last-child button:disabled': {
    border: '2px solid #999EB0',
    color: '#999EB0',
    cursor: 'auto',
    width: '36px',
    height: '36px',
    padding: '7px 8px',
    borderRadius: '5px',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const PaginationButton = styled('button')({
  color: '#999EB0',
  border: 'none',
  cursor: 'pointer',
  background: 'none',
  fontFamily: 'Montserrat',
  fontWeight: 800,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.5px',
  textAlign: 'center',
  verticalAlign: 'middle',
  padding: '0 2px',
  '&:hover': {
    color: '#5166B2',
  },
  '&[aria-current="true"]': {
    color: '#004660 !important',
    fontWeight: 800,
  },
});

export const ContainerPagination = styled(MuiBox)({
  marginTop: '24px',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
});
